//Generated File 
export default class ShowCustomRepIn{
	static readonly EditViewMore = `EditViewMore`;
	static readonly ListViewMore = `ListViewMore`;
}
